import React from "react";
import CardView from "./CardView";

const Card = ({ children }) => {
    return (
        <CardView>{ children }</CardView>
    )
}

export default Card;